import EditPage from "../../components/EditPage";
import PageHeaderEdit from "../../components/PageHeaderEdit";
import PageInfoEdit from "../../components/PageInfoEdit";
import PageInfoListEdit from "../../components/PageInfoListEdit";
import PageInfoListItemEdit from "../../components/PageInfoListItemEdit";
import { UploadFolderIdProvider } from "../../util/UploadFolderIdContext";

export default function Gudstjeneste() {
    const uploadFolderId = '1WdlsHlN5wqkoyxvpMqEhwfJiqyhVw1W-'
    return (
        <UploadFolderIdProvider folderId={uploadFolderId}>
            <EditPage apiPath="page/Gudstjeneste">
                <PageHeaderEdit sectionKey="PageHeader" />
                <PageInfoEdit setImage={true} sectionKey="Sec1" />
                <PageInfoListEdit sectionKey="Sec2">
                    <PageInfoListItemEdit sectionKey="item1"/>
                    <PageInfoListItemEdit sectionKey="item2"/>
                    <PageInfoListItemEdit sectionKey="item3"/>
                    <PageInfoListItemEdit sectionKey="item4"/>
                    <PageInfoListItemEdit sectionKey="item5"/>
                    <PageInfoListItemEdit sectionKey="item6"/>
                </PageInfoListEdit>
                <PageInfoEdit setImage={true} sectionKey="Sec3" />
            </EditPage>
        </UploadFolderIdProvider>
    );
}